// extracted by mini-css-extract-plugin
module.exports = {"base":"Summary_base__2wy-x"};